export default "__VITE_PUBLIC_ASSET__3b9dd9c7__"